import { Breakpoints } from '@/lib/breakpoints';
import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { PrimaryColors, TextColors } from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles(
  {
    root: { position: 'relative', width: '100%', height: '100%', display: 'flex' },
    video: { position: 'relative', width: '100%', height: '100%', transition: 'transform 300ms' },
    audioButton: {
      width: 32,
      height: 32,
      position: 'absolute',
      bottom: Spacings.s12,
      left: Spacings.s12,
      padding: Spacings.s6,
      background: 'rgba(0,0,0,0.8)',
      backdropFilter: 'blur(4px)',
      borderRadius: CornerRadius.r8,
      border: 'none',
      cursor: 'pointer',
      zIndex: 50,
      transition: 'background-color 200ms',
      '&:hover': { background: '#000' },
      '&:focus-visible': { outline: 'none', boxShadow: `0 0 0 2px ${PrimaryColors.base.default}` },
      [Breakpoints.SM]: { bottom: Spacings.s16, left: Spacings.s16 },
    },
    audioIcon: { width: '100%', height: '100%', fill: TextColors.base },
  },
  { name: 'video-player' },
);

export default useStyles;
